import { api } from "../api";

const expenseExportById = async (
    token: string,
    id: number,
    type: string,
    simpleXlsxExport: boolean,
) => {
    return api.get(`/expenses/${id}/${type}/export`, {
        params: {
            simpleXlsxExport,
        },
        responseType: "arraybuffer",
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
};

export default expenseExportById;
